"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarkdown = void 0;
// Browser version
// It is referred by "browser" field
// https://github.com/defunctzombie/package-browser-field-spec
const marked_1 = require("marked");
const dompurify_1 = __importDefault(require("dompurify"));
const core_1 = require("./core");
/**
 * Create Markdown processor
 * @param options
 */
const createMarkdown = (options = {}) => {
    const dompurifyOptions = options.dompurify ? options.dompurify : {};
    return (0, core_1.createCoreProcessor)({
        markdownToHTML: (markdown) => {
            return (0, marked_1.marked)(markdown, options.marked);
        },
        sanitizer: (html) => {
            return dompurify_1.default.sanitize(html, dompurifyOptions);
        }
    });
};
exports.createMarkdown = createMarkdown;
//# sourceMappingURL=browser.js.map